// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productGridCardStyles } from "@turnerBlueprint/Overrides/Widgets/ProductList/ProductListProductGridCard";
import { xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

productGridCardStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        overflow: hidden;
    `,
};

productGridCardStyles.productGridContainerStyles = {
    container: {
        css: css`
            & > .middle-section {
                height: 100%;
            }
        `,
    },
};

productGridCardStyles.productPriceAndActionsStyles = {
    productGridContainer: {
        container: {
            css: css`
                &.pricing-info-container {
                    .top-section {
                        margin-bottom: 12px;
                    }
                    .middle-section {
                        margin-top: auto;
                    }
                    .bottom-section {
                        margin-top: 0;
                    }
                }
            `,
        },
    },
    addToCartButton: {
        css: css`
            min-width: 113px;
        `,
    },
    productUnitOfMeasureSelectStyles: {
        cssOverrides: {
            formField: css`
                ${xScreen("lt", "sm")} {
                    max-width: 85px;
                }
            `,
        },
    },
};

productGridCardStyles.imageWrapper = {
    css: css`
        margin-bottom: 12px;
    `,
};

productGridCardStyles.productListImageStyles = {
    wrapper: {
        css: css`
            position: relative;
            width: 100%;
        `,
    },
    badgeTextWrapper: {
        css: css`
            position: absolute;
            left: 0;
            bottom: 0;
        `,
    },

    productImage: {
        linkWrappingImage: {
            css: css`
                position: relative;
                height: 317px;
                width: fit-content;
                margin: auto;
            `,
        },
        img: {
            width: 317,
            height: 317,
            css: css`
                max-width: 100%;
                max-height: 100%;
                height: auto;
            `,
        },
    },
};

productGridCardStyles.productInformationStyles = {
    container: {
        gap: 0,
    },
    availabilityGridItem: {
        css: css`
            &&& {
                margin: 8px 0;
            }
        `,
    },
    brandGridItem: {
        css: css`
            margin-bottom: 2px;
        `,
    },
    descriptionStyles: {
        productDetailDescription: {
            css: css`
                min-height: 32px; // keep part-numbers aligned
            `,
        },
        productDetailLink: {
            css: css`
                min-height: 32px; // keep part-numbers aligned
            `,
        },
    },
};
